/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'internal': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.42 2.78L8 2.2a4.107 4.107 0 015.8 0 4.108 4.108 0 010 5.8l-1.74 1.74a4.073 4.073 0 01-2.9 1.202 4.073 4.073 0 01-2.9-1.202l-.58-.58L6.84 8l.58.58c.929.93 2.55.93 3.48 0l1.74-1.74a2.465 2.465 0 000-3.48 2.467 2.467 0 00-3.48 0l-.58.58-1.16-1.16zM9.16 8l-.58-.58c-.93-.93-2.551-.93-3.48 0L3.358 9.16a2.465 2.465 0 000 3.48 2.467 2.467 0 003.48 0l.58-.58 1.16 1.16-.58.58A4.085 4.085 0 015.1 15a4.088 4.088 0 01-2.9-1.2 4.108 4.108 0 010-5.8l1.74-1.74a4.073 4.073 0 012.9-1.202c1.096 0 2.127.428 2.9 1.202l.58.58L9.16 8z" _fill="#CC2C34"/>'
  }
})
